import * as React from 'react'

import {
  GlobalBrandLogos,
  GlobalScalableLogos,
} from '@thg-commerce/enterprise-network/src/generated/graphql'
import {
  LogoImageCollection,
  LogoImageCollectionProps,
  LogoImageCarousel,
  LogoImageCarouselProps,
} from '@thg-commerce/enterprise-widget-logo-image-collection'
import { useTheme } from '@thg-commerce/enterprise-core'

import { BaseWidgetProps } from '../types'
import { WidgetTypes } from '../WidgetTypes'

export type HorizontalAlignment = 'left' | 'center' | 'right'

export type LogoImageCollectionRendererProps = BaseWidgetProps &
  (Omit<GlobalBrandLogos, 'query'> | Omit<GlobalScalableLogos, 'query'>) & {
    widgetIndex: number
  }

export const LogoImageCollectionRenderer = (
  props: LogoImageCollectionRendererProps,
) => {
  const theme = useTheme()
  if (props.__typename === WidgetTypes.GlobalBrandLogos) {
    const logoImageCollectionProps:
      | LogoImageCollectionProps
      | LogoImageCarouselProps = {
      title: props.title || undefined,
      logos: [
        {
          link: props.itemOneURL || undefined,
          image: {
            src: props.itemOneImage as string,
            alt: props.itemOneImageAlt || props.title || '',
          },
          widgetIndex: props.widgetIndex,
        },
        {
          link: props.itemTwoURL || undefined,
          image: {
            src: props.itemTwoImage as string,
            alt: props.itemTwoImageAlt || props.title || '',
          },
          widgetIndex: props.widgetIndex,
        },
        {
          link: props.itemThreeURL || undefined,
          image: {
            src: props.itemThreeImage as string,
            alt: props.itemThreeImageAlt || props.title || '',
          },
          widgetIndex: props.widgetIndex,
        },
        ...(props.itemFourImage
          ? [
              {
                link: props.itemFourURL || undefined,
                image: {
                  src: props.itemFourImage,
                  alt: props.itemFourImageAlt || props.title || '',
                },
                widgetIndex: props.widgetIndex,
              },
            ]
          : []),
        ...(props.itemFiveImage
          ? [
              {
                link: props.itemFiveURL || undefined,
                image: {
                  src: props.itemFiveImage as string,
                  alt: props.itemFiveImageAlt || props.title || '',
                },
                widgetIndex: props.widgetIndex,
              },
            ]
          : []),
        ...(props.itemSixImage
          ? [
              {
                link: props.itemSixURL || undefined,
                image: {
                  src: props.itemSixImage as string,
                  alt: props.itemSixImageAlt || props.title || '',
                },
                widgetIndex: props.widgetIndex,
              },
            ]
          : []),
      ],
      horizontalAlignment:
        (props.titleAlign as HorizontalAlignment) || undefined,
    }
    return props.isScrollable ? (
      <LogoImageCarousel
        {...{
          ...logoImageCollectionProps,
          cta: undefined,
          theme: theme.widget.logoImageCollection,
        }}
      />
    ) : (
      <LogoImageCollection {...logoImageCollectionProps} />
    )
  }

  if (props.__typename === WidgetTypes.GlobalScalableLogos) {
    const logoImageCollectionProps: LogoImageCollectionProps = {
      logos: [
        {
          title: props.titleOne || undefined,
          link: props.urlOne || undefined,
          image: {
            src: props.imagePathOne as string,
            alt: props.altTextOne || props.titleOne || '',
          },
          widgetIndex: props.widgetIndex,
        },
        {
          title: props.titleTwo || undefined,
          link: props.urlTwo || undefined,
          image: {
            src: props.imagePathTwo as string,
            alt: props.altTextTwo || props.titleTwo || '',
          },
          widgetIndex: props.widgetIndex,
        },
        ...(props.imagePathThree
          ? [
              {
                title: props.titleThree || undefined,
                link: props.urlThree || undefined,
                image: {
                  src: props.imagePathThree as string,
                  alt: props.altTextThree || props.titleThree || '',
                },
                widgetIndex: props.widgetIndex,
              },
            ]
          : []),
        ...(props.imagePathFour
          ? [
              {
                title: props.titleFour || undefined,
                link: props.urlFour || undefined,
                image: {
                  src: props.imagePathFour as string,
                  alt: props.altTextFour || props.titleFour || '',
                },
                widgetIndex: props.widgetIndex,
              },
            ]
          : []),
        ...(props.imagePathFive
          ? [
              {
                title: props.titleFive || undefined,
                link: props.urlFive || undefined,
                image: {
                  src: props.imagePathFive as string,
                  alt: props.altTextFive || props.titleFive || '',
                },
                widgetIndex: props.widgetIndex,
              },
            ]
          : []),
        ...(props.imagePathSix
          ? [
              {
                title: props.titleSix || undefined,
                link: props.urlSix || undefined,
                image: {
                  src: props.imagePathSix as string,
                  alt: props.altTextSix || props.titleSix || '',
                },
                widgetIndex: props.widgetIndex,
              },
            ]
          : []),
      ],
    }
    return <LogoImageCollection {...logoImageCollectionProps} />
  }

  return null
}
